export default function getPermissions(itemKey){
    let userData = JSON.parse(localStorage.getItem('UserData'))
    let permissions = userData?.permissions

    return permissions?.[itemKey]?.permissions;
}